import { Component, input } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { IMenu } from '@core/models';
import { SvgIconComponent } from '@shared/components';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  standalone: true,
  imports: [RouterModule, RouterLink, SvgIconComponent],
  styleUrls: [],
})
export class MenuItemComponent {
  menuItem = input.required<IMenu>();
}
